import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	periodContent: {
		minWidth: '25vw',
	},
	periodContentExpenses: {
		minWidth: '40vw',
	},
	open: {
		minWidth: '10vw',
	},
}));
